import TenderMessages from './TenderMessages';

export default TenderMessages;
